import { useCallback, useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const useRecaptcha = () => {
  const [captchaToken, setCaptchaToken] = useState('');
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  // @ts-expect-error: Provided by recaptcha
  window.recaptchaOptions = {
    nonce: document.querySelector("meta[name='csp-nonce']")?.getAttribute('content'),
  };

  const handleRecaptcha = useCallback((token: string | null) => {
    setCaptchaToken(token ?? '');
  }, []);

  useEffect(() => {
    const refreshCaptcha = () => {
      if (recaptchaRef.current && captchaToken) {
        recaptchaRef.current.reset();
        setCaptchaToken('');
      }
    };

    let tokenRefreshTimeout: ReturnType<typeof setTimeout> | null = null;

    if (captchaToken) {
      tokenRefreshTimeout = setTimeout(refreshCaptcha, 110000); // 110 seconds
    }

    return () => {
      if (tokenRefreshTimeout) {
        clearTimeout(tokenRefreshTimeout);
      }
    };
  }, [captchaToken]);

  return { captchaToken, handleRecaptcha, recaptchaRef };
};

export default useRecaptcha;
